import { IsString } from "class-validator";
import { Expose } from "class-transformer";

export class MigrationScript {
  @IsString()
  @Expose()
  up!: string;
  @IsString()
  @Expose()
  down!: string;
}
